import { useEffect, useRef } from 'react'

function ScrollProgress() {
  const barRef = useRef(null)

  useEffect(() => {
    const bar = barRef.current
    let ticking = false

    function update() {
      const max = document.documentElement.scrollHeight - window.innerHeight
      if (bar) {
        bar.style.width = `${max ? (window.scrollY / max) * 100 : 0}%`
      }
      ticking = false
    }

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(update)
        ticking = true
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true })
    update()

    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return <div className="scroll-progress" aria-hidden="true" ref={barRef}></div>
}

export default ScrollProgress
